module.exports = __webpack_public_path__ + "img/d_plus.670387df.svg";